import { DOCUMENT, DatePipe } from "@angular/common";
import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/_services/api-data.service";
import { ExportExcelService } from "src/app/_services/export-excel.service";
import { URLS } from "../../_config/api.config";
import { CommonService } from "../../_services/common.service";
import { ToastService } from "../../_services/toast.service";

@Component({
  selector: "app-my-transaction-list",
  templateUrl: "./my-transaction-list.component.html",
  styleUrls: [
    "./my-transaction-list.component.scss",
    "./my-transaction-list.component.overrides.scss",
  ],
})
export class MyTransactionListComponent implements OnInit {
  @ViewChild("filterDropdown") filterDropdown?: ElementRef<HTMLElement>;
  public subscription = new Subscription();
  showSearch = false;
  showFilter: boolean = false;
  isLoading: boolean = false;
  isDownloading: boolean = false;
  perPageInterface = { cssClass: "custom-select-dd per-page-dd" };

  public count = 0;
  public totalCount: any = 0;

  public itemsPerPage = 5;
  key: any;
  public currentPage = 1;
  filterparams: any = {};
  sortType: string = "ASC";
  pageno = 1;
  pagesize = 10;

  transactionList = [];
  readonly skeletonRows = Array.from({ length: 5 }, (_, index) => index);
  readonly skeletonColumns = Array.from({ length: 10 }, (_, index) => index);

  dateRange: FormGroup;
  statusList = [];
  startDate: any;
  endDate: any;
  maxFromDate: any;
  minToDate: any;
  todaysDate = new Date();
  maxDate: any;
  statusFilter = "all";
  searchText: any;
  constructor(
    public commonService: CommonService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private dataService: ApiService,
    private toastService: ToastService,
    private translate: TranslateService,
    private exportService: ExportExcelService,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  ngOnInit() {
    this.initializeData();
  }
  initializeData() {
    this.getTransactionList();
    const element = this.document.querySelector("#scrollId");
    if (element) {
      element.scrollIntoView();
    }
    this.dateRange = this.fb.group({
      fromDate: new FormControl(null),
      toDate: new FormControl(null),
    });
    const date = new Date();
    this.maxFromDate = date.setDate(this.todaysDate.getDate() - 1);
    this.maxDate = this.datePipe.transform(this.todaysDate, "YYYY-MM-dd");
    this.maxFromDate = this.datePipe.transform(this.maxFromDate, "YYYY-MM-dd");

    this.statusList = [
      {
        value: "all",
        label: this.translate.instant("all"),
      },
      {
        value: "DISPATCHED",
        label: this.translate.instant("dispatched"),
      },
      {
        value: "DELIVERED",
        label: this.translate.instant("delivered"),
      },
      {
        value: "NOT_YET_DELIVERED",
        label: this.translate.instant("notYetDelivered"),
      },
      {
        value: "CANCELLATION_REQUESTED",
        label: this.translate.instant("cancellationRequested"),
      },
      {
        value: "CANCELLED",
        label: this.translate.instant("canceled"),
      },
      {
        value: "RETURN_REQUESTED",
        label: this.translate.instant("returnRequested"),
      },
      {
        value: "RETURNED",
        label: this.translate.instant("returned"),
      },
    ];
    this.searchText = null;
  }

  ionViewWillEnter() {
    this.initializeData();
  }

  openFilters() {
    this.showFilter = !this.showFilter;
  }

  @HostListener("document:pointerdown", ["$event"])
  closeFiltersOutside(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (
      this.showFilter &&
      !this.filterDropdown?.nativeElement.contains(target) &&
      !target.closest?.(".mat-datepicker-content, .cdk-overlay-container")
    ) {
      this.showFilter = false;
    }
  }

  get hasFilters(): boolean {
    return !!(
      this.searchText?.trim() ||
      this.statusFilter !== "all" ||
      this.startDate ||
      this.endDate
    );
  }

  search() {
    this.filterparams = {
      page: this.pageno,
      size: this.pagesize,
    };
    if (this.searchText && this.searchText.trim() === "") {
      this.searchText = null;
      return;
    }
    if (this.searchText) {
      this.filterparams.search = this.searchText.trim();
      this.getTransactionList(this.filterparams);
    }
  }

  onChange(event): void {
    this.pageno = event;
    this.getTransactionList(this.filterparams);
  }

  applyBtn() {
    if (!this.filterparams) {
      this.filterparams = {};
    }
    if (
      (this.startDate && !this.endDate) ||
      (!this.startDate && this.endDate)
    ) {
      if (!this.startDate) {
        this.toastService.displayToast(
          this.translate.instant("error.selectFromDate"),
          null,
          "danger",
        );
      }
      if (!this.endDate) {
        this.toastService.displayToast(
          this.translate.instant("error.selectToDate"),
          null,
          "danger",
        );
      }
      return;
    }
    if (this.startDate && this.endDate) {
      this.filterparams.from_date = this.datePipe.transform(
        this.startDate,
        "yyyy-MM-dd",
      );
      this.filterparams.to_date = this.datePipe.transform(
        this.endDate,
        "yyyy-MM-dd",
      );
    }
    if (this.searchText?.trim()) {
      this.filterparams.search = this.searchText.trim();
    } else {
      delete this.filterparams.search;
    }

    if (this.statusFilter !== "all") {
      this.filterparams.shipping_status = this.statusFilter;
    } else {
      delete this.filterparams.shipping_status;
      this.pageno = 1;
      this.getTransactionList();
    }
    const keys = Object.keys(this.filterparams);
    if (keys && keys.length) {
      this.pageno = 1;
      this.getTransactionList(this.filterparams);
    }
    this.showFilter = false;
  }

  clearFilter() {
    delete this.filterparams.from_date;
    delete this.filterparams.to_date;
    delete this.filterparams.shipping_status;
    delete this.filterparams.search;
    this.statusFilter = "all";
    this.searchText = null;
    this.dateRange.reset();
    this.startDate = null;
    this.endDate = null;
    this.pageno = 1;
    this.getTransactionList();
  }

  onSort(event: MouseEvent, key: any) {
    this.key = key;
    const button = event.currentTarget as HTMLElement;
    let order = button.getAttribute("data-order") || "asc";
    if (this.filterparams["sort_by"] != key) {
      order = "asc";
    }
    if (order === "asc") {
      this.sortType = "ASC";
      button.setAttribute("data-order", "desc");
    } else if (order === "desc") {
      this.sortType = "DESC";
      button.setAttribute("data-order", "");
    } else {
      delete this.filterparams["sort_by"];
      delete this.filterparams["sort_type"];
      button.setAttribute("data-order", "asc");
    }
    if (order) {
      this.filterparams["sort_by"] = key;
      this.filterparams["sort_type"] = this.sortType;
      this.pageno = 1;
    }
    this.getTransactionList(this.filterparams);
  }

  clearSearch() {
    this.searchText = null;
    delete this.filterparams.search;
    this.pageno = 1;
    this.getTransactionList(this.filterparams);
  }

  getTransactionList(filterParam?, download?) {
    let params: any = {
      page: this.pageno,
      size: +this.pagesize,
    };
    if (filterParam) {
      params = {
        ...params,
        ...filterParam,
      };
    }
    if (download) {
      params = {
        dropdown: true,
      };
    }
    if (this.isLoading) {
      return;
    }
    if (!download) {
      this.isLoading = true;
      this.transactionList = [];
    }
    this.subscription.add(
      this.dataService.get(URLS.transactionList, params).subscribe(
        (data) => {
          if (data && data.code === 200) {
            if (data.data) {
              if (download) {
                const list =
                  data.data.result && data.data.result.length
                    ? data.data.result
                    : [];
                if (list.length) {
                  this.exportService.saveAsXlsx(list, "transaction_list");
                }
              } else {
                this.transactionList =
                  data.data.result && data.data.result.length
                    ? data.data.result
                    : [];
                this.totalCount = data.data.total_count;
              }
            }
          } else {
            this.totalCount = 0;
            this.toastService.displayToast(data.message, null, "danger");
          }
          this.isLoading = false;
          this.isDownloading = false;
        },
        (error) => {
          this.totalCount = 0;
          this.toastService.displayToast(error.message, null, "danger");
          this.isDownloading = false;
          this.isLoading = false;
        },
      ),
    );
  }

  getStatus(status, forLabel?) {
    if (forLabel) {
      switch (status) {
        case "NOT_YET_DELIVERED":
          return "notYetDelivered";
        case "DISPATCHED":
          return "dispatched";
        case "DELIVERED":
          return "delivered";
        case "CANCELLED":
          return "canceled";
        case "CANCELLATION_REQUESTED":
          return "cancellationRequested";
        case "RETURNED":
          return "returned";
        case "RETURN_REQUESTED":
          return "returnRequested";
        default:
          return "-";
      }
    } else {
      switch (status) {
        case "NOT_YET_DELIVERED":
          return "btn-grey";
        case "DISPATCHED":
          return "btn-green";
        case "DELIVERED":
          return "btn-black";
        case "CANCELLATION_REQUESTED":
        case "RETURN_REQUESTED":
          return "btn-orange";
        case "CANCELLED":
        case "RETURNED":
          return "btn-red";
        default:
          return "btn-blue";
      }
    }
  }

  productName(data: any): string {
    return this.commonService.domDirectionLTR
      ? data?.product_name_en || "-"
      : data?.product_name_ar || "-";
  }

  shippingAddress(data: any): string {
    return this.formatAddress(data, "shipping");
  }

  billingAddress(data: any): string {
    return this.formatAddress(data, "billing");
  }

  private formatAddress(data: any, prefix: "shipping" | "billing"): string {
    const fields = [
      data?.[`${prefix}_address`],
      data?.[`${prefix}_address_city`],
      data?.[`${prefix}_address_region`],
      data?.[`${prefix}_address_country`],
      data?.[`${prefix}_address_zipcode`],
    ].filter(Boolean);
    return fields.length ? fields.join(", ") : "-";
  }

  onPageSizeChange(size: number) {
    this.pagesize = size;
    this.pageno = 1;
    this.getTransactionList(this.filterparams);
  }

  downloadExcel() {
    if (this.isDownloading || this.isLoading) {
      return;
    }
    this.isDownloading = true;
    this.getTransactionList(null, true);
  }
}
